import { createStyles } from "@mantine/emotion";

export default createStyles ( theme => ( {
	container: {
	}
} ) );
